import { useEffect } from 'react';

/**
 * Collapses the AEM parent container to remove extra spacing from host page
 * grid elements (e.g. top-nav-desktop). Use in standalone pages rendered
 * outside Layout (e.g. Apply) where the global main.tsx collapse may not apply.
 */
export function useCollapseAemContainer() {
  useEffect(() => {
    const rootEl = document.getElementById('root-food-shelter-love');
    const parentContainer = rootEl?.closest('.cmp-container');
    if (parentContainer instanceof HTMLElement) {
      parentContainer.style.display = 'inline';
    }
  }, []);
}
